import React, { useEffect } from 'react'
import { Card, Skeleton, Table } from 'antd'
import { formatAmount } from 'utils'
import { useHardwareSelector } from 'store/hardwareSlice/hardwareReducer'
import { getHardwareTotal } from 'screens/main/settings/manage-subscription/helper'
import { useDispatch } from 'react-redux'
import { getHardwareList } from 'store/hardwareSlice/hardwareActions'
import { useAuthSelector } from 'store/authSlice/authReducer'

const columns = [
  {
    title: 'Hardware Type',
    dataIndex: 'HardwareType',
    className: 'ant-table-row-cell-break-word',
  },
  {
    title: 'Device UUID',
    dataIndex: 'DeviceUUID',
    className: 'ant-table-row-cell-break-word',
  },
  {
    title: 'Device Name',
    dataIndex: 'DeviceName',
    className: 'ant-table-row-cell-break-word',
  },
  {
    title: 'Amount',
    dataIndex: 'MonthlyCost',
    className: 'ant-table-row-cell-break-word',
    render: (_, { MonthlyCost }) => formatAmount(MonthlyCost),
  },
]

const OrganizationHardware = () => {
  const dispatch = useDispatch()
  const { organization } = useAuthSelector()
  const {
    loading: { fetchHardwareList },
    hardwareList,
  } = useHardwareSelector()

  const formatedHardwareList = [
    ...hardwareList,
    {
      HardwareType: 'Total',
      MonthlyCost: getHardwareTotal(hardwareList),
    },
  ]

  useEffect(() => {
    if (organization?.id) {
      dispatch(
        getHardwareList({
          onlyOrganization: true,
          organizationId: organization?.id,
        }),
      )
    }
  }, [dispatch, organization?.id])

  const isHardwareAllocated = formatedHardwareList?.length > 1
  return (
    <Card>
      <Skeleton loading={fetchHardwareList} active paragraph={{ rows: 8 }}>
        {isHardwareAllocated ? (
          <Table
            className="t-w-[300px] sm:t-w-full"
            tableLayout="auto"
            scroll={{ x: 'max-content' }}
            columns={columns}
            dataSource={formatedHardwareList || []}
            bordered={false}
            pagination={false}
          />
        ) : (
          <div>No Hardware Allocated To Your Organization</div>
        )}
      </Skeleton>
    </Card>
  )
}

export { OrganizationHardware }
